var _rect, _circle, _rect2, _circle2, _rect3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedOptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 38,
    width: 45,
    height: 4,
    rx: 2,
    fill: "#8D8BD3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 40,
    r: 6,
    fill: "#57AC2D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 45,
    height: 4,
    rx: 2,
    fill: "#8D8BD3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 23,
    r: 6,
    fill: "#FF0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 45,
    height: 4,
    rx: 2,
    fill: "#8D8BD3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 6,
    r: 6,
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedOptionIcon);
export default __webpack_public_path__ + "static/media/selected-option-icon.aaa10d947ce7f87a54bab0749e7f790d.svg";
export { ForwardRef as ReactComponent };